@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <div fxLayout="row" fxLayoutAlign="start center" class="w-100">
            @if (showSearchBar && form.controls.query) {
                <mat-form-field
                    class="w-100"
                    fxFlex
                    [class.filter-not-empty]="!!form.controls.query.value">
                    <input [placeholder]="'i18n_af_placeholderSearch#' + placeholderContext | translate" matInput type="text"
                           formControlName="query"
                           (keydown)="onSearchKeydown($event)"/>
                    <ui-kit-svg matPrefix matRipple class="i-16 circle p-8 ml-8 c-primary-gray-600" name="ic_search"/>
                    @if (form.controls.query.value?.trim()) {
                        <ui-kit-svg matSuffix matRipple
                                    class="i-16 circle pointer p-8 ml-8 mr-8 c-primary-gray-600"
                                    name="ic_cross"
                                    (click)="clearSearch()"/>
                    }
                </mat-form-field>
            }
            @if (hasFilterFields) {
                <div
                    matRipple
                    class="filter-toggle"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    [class.filtered]="isFilterSelected"
                    (click)="openFilters()">
                    <ui-kit-svg class="i-16" name="ic_filter"/>
                    <div class="ml-8 t3 no-select">{{ 'i18n_af_labelFilter' | translate }}</div>
                </div>
            }
            @if (hasContent) {
                <ng-content></ng-content>
            }
        </div>
        @if (chips?.length || (showImport || showExport)) {
            <div fxLayout="row"
                 [fxLayoutAlign]="(chips?.length ? 'space-between' : 'end') + ' center'" class="w-100"
                 [class.mt-24]="showSearchBar && form.controls.query">
                @if (chips?.length && chipsFormControlName) {
                    <div fxLayout="row" fxLayoutAlign="start center">
                        @if (chips.length) {
                            <mat-chip-listbox
                                [multiple]="false"
                                [selectable]="true"
                                [formGroupName]="chipsFormControlName"
                                [hideSingleSelectionIndicator]="true">
                                @for (chip of chips; track chip) {
                                    <mat-chip-option class="t4"
                                                     [selected]="form.get(chipsFormControlName).get(chip)?.value"
                                                     (selectionChange)="onChipSelectionChange($event, chip)">
                                        {{ 'i18n_af_filter_field_' + chipsFormControlName + '#' + chip | translate }}
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        }
                    </div>
                }
                @if (showImport || showExport) {
                    <div fxLayout="row" fxLayoutAlign="start center">
                        @if (showExport) {
                            <ui-kit-svg matRipple
                                        [matRippleCentered]="true"
                                        [matRippleUnbounded]="true"
                                        class="i-24 pointer"
                                        name="ic_upload"
                                        (click)="importFraudList()"/>
                        }
                        @if (showImport) {
                            <ui-kit-svg matRipple
                                        [matRippleCentered]="true"
                                        [matRippleUnbounded]="true"
                                        class="i-24 pointer ml-12"
                                        name="ic_download_document"
                                        (click)="exportFraudList()"/>
                        }
                    </div>
                }
            </div>
        }
    </form>
}
